module.exports = __webpack_public_path__ + "img/places.af23784a.svg";